module.exports = __webpack_public_path__ + "img/facade-contemporary-double.7ddf81cf.png";